import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ApplicationActions } from '../actions/application.actions';

@Injectable()
export class ACHProfileCanActivate implements CanActivate {
  constructor(appActions: ApplicationActions) {
    this.appActions = appActions;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const stepCompleted = this.appActions.getData('StepCompleted');
    if (stepCompleted !== null && stepCompleted.achProfile === true) {
      return false;
    } else {
      return true;
    }
  }
}
